// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"d1e2ad9de5d562f8cfd2","691":"702e22bfbebb5b04ad5f"}[chunkId] + ".js";
};